import {
  ViewerMode,
  type ImportedModelTabType,
} from '@puppycad/cad-core'

export interface SyncVersionPreviewIdleViewerModeOptions {
  /** 当前预览页底部标签类型。 */
  activeTabType: ImportedModelTabType | null | undefined
  /** 同步 web-client 的草图/空间模式 store。 */
  setSketchViewerMode: (mode: ViewerMode) => void
  /** 同步 cad-core Viewer 的真实交互模式。 */
  setViewerMode: (mode: ViewerMode) => void
}

/**
 * 根据版本预览当前标签类型解析空闲交互模式。
 *
 * 设计说明：
 * 1. 版本预览虽然只读，但设计树 hover / click 的模型高亮仍然依赖 cad-core 的交互视觉状态；
 * 2. 装配体导入模型树高亮只由 AssemblyTransitionState 消费，因此装配体标签必须进入 Assembly 模式；
 * 3. 普通零件继续使用 Default，避免把装配体语义扩散到非装配场景。
 *
 * @param activeTabType 当前预览页底部标签类型。
 * @returns 预览页应落回的空闲 Viewer 模式。
 */
export function resolveVersionPreviewIdleViewerMode(
  activeTabType: ImportedModelTabType | null | undefined,
): ViewerMode {
  return activeTabType === 'assembly'
    ? ViewerMode.Assembly
    : ViewerMode.Default
}

/**
 * 同步版本预览页空闲交互模式到 store 与 Viewer。
 *
 * 说明：该函数只同步视图交互状态，不改变 CAD 主模型状态；因此不接入 Undo/Redo。
 *
 * @param options 模式同步依赖。
 * @returns 本次同步后的 Viewer 模式。
 */
export function syncVersionPreviewIdleViewerMode(
  options: SyncVersionPreviewIdleViewerModeOptions,
): ViewerMode {
  const mode = resolveVersionPreviewIdleViewerMode(options.activeTabType)
  options.setSketchViewerMode(mode)
  options.setViewerMode(mode)
  return mode
}
